import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Affranchi } from '../../models/Affranchi';

@Component({
  selector: 'app-affranchi-details',
  imports: [
    MatCardModule,
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './affranchi-details.component.html',
  styleUrl: './affranchi-details.component.css',
})
export class AffranchiDetailsComponent implements OnInit {
  affranchi?: Affranchi;

  typeEcart?: string;
  valeurEcart?: number;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    this.affranchi = this.data.affranchi;

    if (this.affranchi?.incidentAffranchi?.ecart) {
      for (const [key, value] of Object.entries(
        this.affranchi?.incidentAffranchi?.ecart
      )) {
        if (typeof value === 'number') {
          this.typeEcart = key;
          this.valeurEcart = value;
          break;
        }
      }
    }
  }
}
